import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import axios from "axios";

function AttendanceRecords() {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    // Get employeeNo from localStorage (or from props/context)
    const employee = JSON.parse(localStorage.getItem("employee") || "{}");
    if (employee.employeeNo) {
      axios
      
        .get(`https://hrms.urbango.co.in/server/index.php?endpoint=attendance&employeeName=${encodeURIComponent(employee.employeeName)}`)
        .then((res) => setRecords(res.data))
        .catch(() => setRecords([]));
    }
  }, []);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.text("Attendance Records", 14, 16);
    doc.autoTable({
      startY: 20,
      head: [["Date", "Employee", "Check In", "Check Out", "Duration"]],
      body: records.map((r) => [
        r.date,
        employeeName(r.employee),
        r.checkIn,
        r.checkOut,
        r.duration,
      ]),
    });
    doc.save("attendance_records.pdf");
  };

  // Utility to show employee name, or just show ID if name is missing
  const employeeName = (emp) => {
    const employee = JSON.parse(localStorage.getItem("employee") || "{}");
    return employee.employeeName || emp;
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Attendance Records</h2>
      <table className="w-full border mb-4">
        <thead>
          <tr className="bg-gray-200">
            <th>Date</th>
            <th>Employee</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {records.map((r, i) => (
            <tr key={i} className="bg-white text-center">
              <td>{r.date}</td>
              <td>{employeeName(r.employee)}</td>
              <td>{r.checkIn}</td>
              <td>{r.checkOut}</td>
              <td>{r.duration}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={downloadPDF} className="bg-blue-500 text-white px-4 py-2">
        Download as PDF
      </button>
    </div>
  );
}

export default AttendanceRecords;
